import { Subscription } from "./SubscriptionInterface";

export interface UserType {
    id: number;
    typeName: string;
    logo: string;
    plans: Subscription[]
}

export const mapUserType = (data: any): UserType => {
    if (!data) {
      throw new Error('Invalid user type data');
    }
  
    const userType: UserType = {
      id: data.id,
      typeName: data.type_name,
      logo: data.logo,
      plans:[]
    };
  
    return userType;
  };

  export const mapUserTypes = (data: any[]): UserType[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid users data');
    }
  
    return data.map(mapUserType);
  };